export default __webpack_public_path__ + "static/media/responsive-img.3afc98b7.jpg";